import type { SizedIconProps } from '../BaseIcon';
import { BaseIcon } from '../BaseIcon';
import { IconSize } from '../../../../enums';

type ThumbsDownIconProps = Omit<SizedIconProps, 'children' | 'hasLegacyStrokeStyles'>;

export const ThumbsDownIcon = ({
  strokeWidth,
  size = IconSize.Standard,
  width,
  height,
  ...props
}: ThumbsDownIconProps) => {
  const isMini = size === IconSize.Mini;
  const iconWidth = width ?? (isMini ? 12 : 17);
  const iconHeight = height ?? (isMini ? 12 : 16);

  return (
    <BaseIcon width={iconWidth} height={iconHeight} viewBox="0 0 17 16" fill="none" {...props}>
      <g clipPath="url(#clip0_9016_550)">
        <path d="M12 9.5L11.8975 9.49512C11.3933 9.44379 11 9.01768 11 8.5L11 0.999999C11 0.447714 11.4477 -4.85396e-07 12 -4.37114e-07L16 -8.74228e-08C16.5523 -3.91405e-08 17 0.447715 17 1L17 8.5L16.9951 8.60254C16.9438 9.10667 16.5177 9.5 16 9.5L12 9.5ZM15 2L13 2L13 7.5L15 7.5L15 2Z" />
        <path d="M8 13C8 13.325 8.07836 13.5023 8.14453 13.6016C8.212 13.7028 8.30803 13.7823 8.43164 13.8467L11 8.28027L11 2L5.08399 2C4.62008 2.00002 4.21677 2.319 4.11035 2.77051L2.7627 8.5L7 8.5C7.26522 8.5 7.5195 8.60543 7.70703 8.79297C7.89457 8.9805 8 9.23478 8 9.5L8 13ZM6 10.5L2.7627 10.5C1.5536 10.5 0.640388 9.44293 0.774415 8.27637L0.81543 8.04199L2.16406 2.3125C2.48307 0.957593 3.692 1.92134e-05 5.08399 -6.9204e-07L12 -8.74228e-08C12.2652 -6.42368e-08 12.5195 0.105432 12.707 0.292969C12.8946 0.480505 13 0.734783 13 1L13 8.5C13 8.64463 12.9688 8.78761 12.9082 8.91895L9.9082 15.4189L9.83789 15.5459C9.65519 15.8264 9.34122 16 9 16L9 15C9 15.9848 8.99952 15.9998 8.99902 16L8.97852 16C8.96921 15.9998 8.95752 15.9995 8.94434 15.999C8.91789 15.9981 8.88358 15.9961 8.84277 15.9932C8.76157 15.9874 8.65213 15.9765 8.52344 15.9551C8.27045 15.9129 7.91745 15.8269 7.55273 15.6445C7.1841 15.4602 6.78513 15.1679 6.48047 14.7109C6.17164 14.2477 6 13.675 6 13L6 10.5Z" />
      </g>
      <defs>
        <clipPath id="clip0_9016_550">
          <rect width="16.2387" height="16" fill="white" transform="translate(0.76123)" />
        </clipPath>
      </defs>
    </BaseIcon>
  );
};

ThumbsDownIcon.displayName = 'ThumbsDownIcon';
